import React from "react";

/** WhatsApp-like: 1 Haken = gesendet, 2 Haken = zugestellt, 2 grüne = gelesen */
export default function MessageStatusIcon({
  delivered = false,
  read = false,
  size = 18,
  colorSent = "#888",
  colorDelivered = "#888",
  colorRead = "#2ecc40",
  titleSent = "Gesendet",
  titleDelivered = "Zugestellt",
  titleRead = "Gelesen",
}) {
  const state = read ? "read" : delivered ? "delivered" : "sent";
  const color = state === "read" ? colorRead : state === "delivered" ? colorDelivered : colorSent;
  const title = state === "read" ? titleRead : state === "delivered" ? titleDelivered : titleSent;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 22 22"
      role="img"
      aria-label={title}
      title={title}
      style={{ verticalAlign: "middle", flex: "0 0 auto" }}
    >
      {/* Haupt-Haken */}
      <path d="M6 12l4 4 6-8" stroke={color} strokeWidth="2.2" fill="none" strokeLinecap="round" />
      {/* Zweiter Haken nur bei delivered/read */}
      {state !== "sent" && (
        <path d="M2 12l4 4 6-8" stroke={color} strokeWidth="2.2" fill="none" strokeLinecap="round" />
      )}
    </svg>
  );
}
